
import { useGallery, useGame, useGameWrapper, useMissionTrigger, usePage } from '../../contexts'
import styled from 'styled-components'
import { Outlet } from 'react-router-dom'
import { customTheme } from '../../styles/theme'
import Settings from '../settings'
import Footer from '../footer/footer'

const BaseLayout = ({ menuDefault, menuFooter }: any) => {
  const { background } = usePage()
  const { isOpen } = useMissionTrigger()
  const { isShowing } = useGallery()
  const { isTogether } = useGame()
  const { zoomModalIsOpen } = useGameWrapper()

  return (
    <>
      <FullWrapper $scroll={!isOpen && !isShowing && !zoomModalIsOpen}>
        {background && <ImageBody src={background} />}
        <Outlet />
        {!isTogether() && (
        <>
          <Wrapper>
            {!['/greetings', '/mission'].includes(window.location.pathname) && <Footer />}
          </Wrapper>
          <WrapperMobile>
            {!['/login', '/esqueci-minha-senha', '/recuperar-senha'].includes(window.location.pathname) && <Settings mobile={true} />}
            {!['/greetings', '/login', '/esqueci-minha-senha', '/recuperar-senha', '/mission'].includes(window.location.pathname) && <Footer mobile={true} />}
          </WrapperMobile>
        </>)}
      </FullWrapper>
    </>
  )
}

export default BaseLayout

const FullWrapper = styled.div<any>`
  height: 100vh;
  overflow: auto;
  
  ${(props) => !props.$scroll && `position: fixed;
    margin-top: 0;
    width: 100%;`
  }

  @media (max-width: ${customTheme.breakpoints[1]}) {
    height: 100vh;
    min-height: 100vh;
    position: relative;

    ${(props) => !props.scroll && `position: fixed;
      margin-top: 0;
      width: 100%;`
    }
  }
`

const ImageBody = styled.img`
  position: absolute;
  height: 100%;
  width: 100%;
  object-fit: cover;
  z-index: -1;
`

export const Wrapper = styled.div`
  display: flex;
  
  @media (max-width: ${customTheme.breakpoints[1]}) {
    display: none;
  }
`

export const WrapperMobile = styled.div`
  display: none;
  
  @media (max-width: ${customTheme.breakpoints[1]}) {
    display: flex;
    justify-content: center;
  }
`
